const routes = [
  {
    path: '/salesStudentList',
    name: 'salesStudentList',
    meta: {
      title: '学员列表',
      volcengine: true
    },
    component: () => import('@/pages/salesV2/salesStudentList/salesStudentList.vue')
  },
  {
    path: "/salesStudentList/detail",
    name: "salesStudentList/detail",
    component: () => import("@/pages/educational/students/regular/detail.vue"),
    meta: {
      title: "学员详情",
      hasBack: true,
    },
  },
]

export default routes
